import type { TranslationMessages } from '../types';

export const customer_reviews: TranslationMessages = {
  name: 'Customer Reviews |||| Customer Reviews',
  title: 'Customer Reviews',
  subtitle: 'Customer feedback and ratings for your business',
  loading: 'Loading customer reviews...',
  failed_load: 'Failed to load customer reviews',
  average_rating: 'Average Rating',
  total_ratings: 'Total Reviews',
  this_week: 'this week',
  high_ratings: 'High Ratings',
  high_ratings_desc: '4+ star reviews',
  positive_feedback: 'Positive',
  five_star: '5 star reviews',
  rating_distribution: 'Rating Distribution',
  rating_distribution_desc: 'Breakdown of all customer ratings',
  filters_sorting: 'Filters & Sorting',
  filter_by: 'Filter by:',
  all_reviews: 'All Reviews',
  high_ratings_filter: 'High Ratings (4+)',
  low_ratings_filter: 'Low Ratings (2-)',
  sort_by: 'Sort by:',
  sort_date: 'Date (Newest)',
  sort_rating: 'Rating (Highest)',
  sort_category: 'Category',
  customer_reviews: 'Customer Reviews',
  customer_reviews_desc: 'Recent customer feedback and ratings',
  no_reviews: 'No reviews found',
  customer: 'Customer',
  contact_info: 'Contact Info',
  };
